//bind_Modal
import bind_modal from '@/components/AreaBind';

//pass_comfirm
import pass_comfirm from '@/components/PassComfirm';

// msg_modal
import msg_modal from '@/components/MsgModal';

// exp_modal
import exp_modal from '@/components/ExpBuy';

// comfirm_exp_Modal
import comfirm_exp_modal from '@/components/ExpComfirm';

// score_modal
import score_modal from '@/components/ScoreModal';

// evt_rule
import evt_rule from '@/components/EvtRule';

// copy_Modal
import copy_modal from '@/components/CopyModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

// trade_Modal
import trade_modal from '@/components/TradeModal';

// trade_token
import trade_token from '@/components/TokenTrade';

// trade_record
import trade_record from '@/components/RecordModal';

// pass_detail
import pass_detail from '@/components/PassDetailModal';

// Toast
import toast from '@/components/Toast'

let utils = {
    $bind_modal : bind_modal,
    $pass_comfirm : pass_comfirm,
    $msg_modal : msg_modal,
    $score_modal : score_modal,
    $evt_rule : evt_rule,
    $exp_modal : exp_modal,
    $comfirm_exp_modal : comfirm_exp_modal,
    $copy_modal : copy_modal,
    $invite_apply : invite_apply,
    $trade_modal : trade_modal,
    $trade_token : trade_token,
    $trade_record : trade_record,
    $pass_detail : pass_detail,
    $toast : toast,
}

export default utils;